import React from 'react';
import SourceManagerComponent from '../components/SourceManagerComponent';

function Sources() {
    return (
        <div>
            <h1>Sources</h1>
            <SourceManagerComponent />
        </div>
    );
}

export default Sources;
